import { render, staticRenderFns } from "./FadeInBackground.vue?vue&type=template&id=48ca8a8a"
import script from "./FadeInBackground.vue?vue&type=script&lang=js"
export * from "./FadeInBackground.vue?vue&type=script&lang=js"
import style0 from "./FadeInBackground.vue?vue&type=style&index=0&id=48ca8a8a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports